// Brand + content constants for 101 Contractor LLC

export const BRAND = {
  name: "101 Contractor LLC",
  short: "101",
  slogan: "Quality, Efficiency, Trust — That's 101",
  phone: "865-300-1940",
  phoneHref: "tel:+18653001940",
  email: "101llccontractor@gmail.com",
  location: "East Tennessee",
  logo: "https://customer-assets.emergentagent.com/job_outdoor-oasis-18/artifacts/qlbzw3o2_DCD71D7F-D335-4667-9043-40B4B6F8BB8F.jpeg",
};

export const SOCIALS = [
  { label: "Instagram", href: "https://www.instagram.com/101_contractor" },
  { label: "TikTok", href: "https://www.tiktok.com/@101_contractor_llc" },
  { label: "Facebook", href: "https://www.facebook.com/share/1ULPPmnUDW/" },
];

export const REVIEWS = [
  {
    name: "ArSquared",
    when: "3 months ago",
    text: "Did an excellent and exquisite job replacing our drive-thru window. Couldn't have asked for a better job and super quick turnaround. We were able to keep our window open for most of the process as well. Great guy too!",
  },
  {
    name: "Kamal Sabi",
    when: "2 months ago",
    text: "Malik and his team did a great job on my property! They removed the old mulch and completely transformed my front yard. They are very professional, easy to work with, and the results exceeded my expectations. Would highly recommend their service!",
  },
];

const A = "https://customer-assets.emergentagent.com/job_outdoor-oasis-18/artifacts";
const B = "https://customer-assets.emergentagent.com/job_89bf7340-b7c1-4502-9c60-de2dcdb00647/artifacts";

export const IMAGES = {
  heroStair: `${A}/rkf2esly_IMG_4468.webp`, // illuminated flagstone stairway at dusk
  firepitAutumn: `${A}/9emmd77d_IMG_1559.webp`, // golden-hour flagstone fire pit + retaining wall
  paverFirepit: `${B}/ugxnenam_IMG_4986.webp`, // paver patio + fire pit (upright)
  aerialFirepit: `${B}/cbgmjwnu_IMG_4968.webp`, // aerial circular flagstone fire pit
  poolClouds: `${A}/u38kqbna_IMG_4467.webp`, // pool + circular fire pit under dramatic sky
  lawn: `${A}/k7he12ok_IMG_4786.webp`, // freshly striped landscaped lawn
  walkwayDoor: `${A}/c4ojtnq0_IMG_4763.webp`, // flagstone walkway to front door
  aerialPool: `${A}/irxn9hnm_IMG_4648.webp`, // aerial pool + fire feature
  // process / craftsmanship (upright)
  patioBuild: `${A}/ib5beans_IMG_1884.webp`, // flagstone patio being built
  tileShower: `${A}/lyn7aut4_IMG_3910.webp`, // shower tile in progress
  floorTile: `${A}/7lg741we_IMG_3870.webp`, // floor tile being set
  kitchen: `${B}/692rrva0_IMG_0640.webp`, // kitchen remodel (rotate clockwise)
  crew: `${A}/dplm7ehg_IMG_5962.webp`, // branded crew building deck
  sod: `${A}/j0breeti_IMG_1539.webp`, // sod rolls being installed
  poolBefore: `${A}/tfdht9et_IMG_1600.webp`, // neglected pool (before)
  poolAfter: `${A}/irxn9hnm_IMG_4648.webp`, // restored pool + fire pit, ground level (after)
  firepitBuild: `${A}/74r3f55t_IMG_1467.webp`, // fire pit patio being built
  kitchenAfter: `${A}/94m3yogq_IMG_0640.webp`, // finished modern kitchen (upright)
  kitchenBefore: `${A}/dhvww5uo_image.webp`, // dated kitchen (rotated sideways)
  bathPebble: `${A}/hieetrx2_IMG_4537.webp`, // finished bath, pebble-floor shower + toilet
  bathMarble: `${A}/ay7x876m_IMG_4541.webp`, // finished marble walk-in shower
  firePitProjects: `${A}/kpbnzlgs_FullSizeRender.webp`, // finished flagstone fire pit patio
  walkwayAfter: `${A}/u1oro9rm_IMG_1556.webp`, // flagstone walkway + mulch beds (after)
  porchBefore: `${A}/3iialwzz_51B92A6F-3C2E-4209-8B9C-2C37D017351E.webp`, // overgrown yard (before)
  darkDeck: `${A}/5ocjg5yr_image000000.JPG`, // dark stained multi-level deck
  treeMulch: `${A}/4bguun1c_IMG_5465.webp`, // tree with fresh mulch ring
  retainWall: `${A}/1smwrq3l_IMG_1875.webp`, // block retaining wall + steps
  treeDeck: `${A}/g2lyqbf4_3B53919F-9008-439C-85CB-255BAFE65C0C.webp`, // wood deck around trees (rotate)
};

// Interior remodel before / after (Projects page)
export const REMODELS = [
  {
    title: "Kitchen Remodel",
    tag: "Interior · Before → After",
    before: IMAGES.kitchenBefore,
    after: IMAGES.kitchenAfter,
    beforeRotate: true,
  },
];

// Before / after — same project, build → finished
export const TRANSFORMATIONS = [
  {
    title: "Pool & Backyard Restoration",
    tag: "Landscape + Hardscape",
    before: IMAGES.poolBefore,
    after: IMAGES.poolAfter,
  },
  {
    title: "Walkway & Landscape",
    tag: "Landscape · Before → After",
    before: IMAGES.porchBefore,
    after: IMAGES.walkwayAfter,
  },
];

// "What we mostly do" aligned columns
export const COLUMNS = [
  { title: "Outdoor Living Space", src: IMAGES.firepitAutumn, tag: "Hardscape" },
  { title: "Mulch & More", src: IMAGES.treeMulch, tag: "Landscape" },
  { title: "Decks", src: IMAGES.treeDeck, tag: "Custom Build", rotate: true },
  { title: "Retaining Wall", src: IMAGES.retainWall, tag: "Hardscape" },
  { title: "Crew at Work", src: IMAGES.crew, tag: "Every Project" },
];

export const SERVICES = [
  { n: "01", title: "Hardscape", desc: "Paver patios, retaining walls, stone walkways & steps engineered to last generations." },
  { n: "02", title: "Landscaping", desc: "Grading, planting beds, lawns & full landscape design that transforms a property." },
  { n: "03", title: "Patios & Fire Pits", desc: "Custom outdoor living rooms built around fire, stone & the way you gather." },
  { n: "04", title: "Fireplaces", desc: "Stone fireplaces & fire features that anchor a backyard and pull people in." },
  { n: "05", title: "Decks", desc: "Custom decks designed for how you actually live in your outdoor space." },
  { n: "06", title: "Remodels", desc: "Interior & exterior remodels — kitchens, baths and full refreshes." },
  { n: "07", title: "Demolition", desc: "Safe, clean teardowns that make way for whatever comes next." },
  { n: "08", title: "Land Clearing", desc: "Clearing, grubbing & site prep to get any project off the ground." },
];

export const CHAPTERS = [
  {
    n: "01",
    title: "Custom hardscape & landscape",
    body: "Every patio, wall and walkway is built from scratch for your property — no templates, no shortcuts. Natural stone, pavers and thoughtful grading, done right the first time.",
  },
  {
    n: "02",
    title: "The backyard you dream about",
    body: "Outdoor patios, fireplaces, fire pits and complete backyard transformations. We build the space you picture when you imagine spending an evening outside.",
  },
  {
    n: "03",
    title: "Market-ready in record time",
    body: "We help homeowners and realtors get houses ready for the market — remodels, curb appeal and clean-ups that move properties faster and lift their value.",
  },
];

// Behind-the-scenes / craftsmanship shots (all upright)
export const PROCESS = [
  { src: IMAGES.patioBuild, step: "Stone", label: "Natural flagstone, set by hand" },
  { src: IMAGES.tileShower, step: "Finish", label: "Precision tile & waterproofing" },
  { src: IMAGES.paverFirepit, step: "Precision", label: "Cut with precision" },
];

export const GALLERY = [
  { src: IMAGES.firepitAutumn, tag: "Fire Feature", span: "big" },
  { src: IMAGES.walkwayDoor, tag: "Stone Walkway", span: "tall" },
  { src: IMAGES.paverFirepit, tag: "Paver Patio", span: "wide" },
  { src: IMAGES.aerialFirepit, tag: "Hardscape", span: "wide" },
  { src: IMAGES.poolClouds, tag: "Backyard", span: "big" },
  { src: IMAGES.heroStair, tag: "Landscape Lighting", span: "tall" },
  { src: IMAGES.lawn, tag: "Landscaping", span: "wide" },
  { src: IMAGES.firePitProjects, tag: "Fire Pit Patio", span: "wide" },
  { src: IMAGES.bathPebble, tag: "Bathroom", span: "tall" },
  { src: IMAGES.bathMarble, tag: "Bathroom", span: "tall" },
  { src: IMAGES.darkDeck, tag: "Deck", span: "tall" },
];

